export default (translate = undefined, key = undefined) => {
  return [
    (value) => {
      if (!value) {
        // if translation object and key send then return the translated message otherwise return empty string
        return translate && key ? translate(key) : '';
      } else {
        return true;
      }
    },
  ];
};
